import React, { Component } from 'react'
import qs from 'qs'
import axios from 'axios'
import { Formik, Form, Field } from 'formik';
import Message from './Message';

class Register extends Component {
  
  state = {
    isLoading: false,
    isRegistered: false
  }
  
  /*
    10 zeichen und ein sonderzeichen (!?$_-<>) in password (vorher validieren)
  */

  render() {
    if(this.state.isRegistered) {
      return <Message headline={"Registierung"} message={"Registierung mit Link aus E-Mail bestätigen."} />
    }

    return (
      <div class="d-flex flex-column flex-root">
        <div class="login login-3 wizard d-flex flex-column flex-lg-row flex-column-fluid">
          <div class="login-content flex-row-fluid d-flex flex-column p-10">
            <div class="d-flex flex-row-fluid flex-center">
              <div class="login-form">
                <div class="pb-5 pb-lg-15">
                  <h4 class="text-muted font-weight-bold font-size-h4">Pivicon ID</h4>
                  <h3 class="font-weight-bolder text-dark font-size-h2 font-size-h1-lg">Registrierung</h3>
                </div>
                <Formik
                  initialValues={{ username: '', firstname: '', lastname: '', password: '', password2: '' }}
                  validateOnChange={false}
                  validateOnBlur={false}
                  validate={values => {
                    const errors = {};
                    if (!values.username) {
                      errors.username = true;
                    }
                    if (!values.firstname) {
                      errors.firstname = true;
                    }
                    if (!values.lastname) {
                      errors.lastname = true;
                    }
                    if (values.password.length < 10) {
                      errors.password = true;
                      errors.password2 = true;
                    }
                    if (values.password !== values.password2) {
                      errors.password = true;
                      errors.password2 = true;
                    }
                    return errors;
                  }
                  }
                  onSubmit={(values, { setSubmitting, setFieldError }) => {
                    this.setState({ isLoading: true })

                    axios({
                      method: 'POST',
                      url: process.env.REACT_APP_API_URL + '/users/tasks/register',
                      data: qs.stringify({
                        'name': values.username,
                        'password': values.password,
                        'data': {
                            "forename": values.firstname,
                            "surname": values.lastname,
                            "street": "Straße 1",
                            "code": 12345,
                            "city": "Stadt",
                            "country": "Deutschland"
                        }
                      })
                    }).then(response => {
                        this.setState({ isLoading: false })
                        setSubmitting(false)
                        if (response.status === 201) {
                          this.setState({ isRegistered: true })
                        }
                      })
                      .catch(error => {
                        this.setState({ isLoading: false })
                        if (error.response.status === 409) {
                          setFieldError('username', true);
                        } else {
                          setFieldError('username', true);
                          setFieldError('firstname', true);
                          setFieldError('lastname', true);
                          setFieldError('password', true);
                          setFieldError('password2', true);
                        }
                      })
                  }}
                >
                  {({ errors, isSubmitting }) => (
                    <Form class="kt-form">
                      <div class="form-group">
                        <label class="font-size-h5 font-weight-bolder text-dark">E-Mail</label>
                        <Field type="text" name="username" placeholder="max@mustermann.de" class={errors.username ? "form-control h-auto py-6 rounded-lg border-danger is-invalid" : "form-control h-auto py-6 rounded-lg border-1"} autocomplete="off" />
                      </div>
                      <div class="form-group">
                        <label class="font-size-h5 font-weight-bolder text-dark">Vorname</label>
                        <Field type="text" name="firstname" placeholder="Max" class={errors.firstname ? "form-control h-auto py-6 rounded-lg border-danger is-invalid" : "form-control h-auto py-6 rounded-lg border-1"} autocomplete="off" />
                      </div>
                      <div class="form-group">
                        <label class="font-size-h5 font-weight-bolder text-dark">Nachname</label>
                        <Field type="text" name="lastname" placeholder="Mustermann" class={errors.lastname ? "form-control h-auto py-6 rounded-lg border-danger is-invalid" : "form-control h-auto py-6 rounded-lg border-1"} autocomplete="off" />
                      </div>
                      <div class="form-group">
                        <label class="font-size-h5 font-weight-bolder text-dark">Passwort</label>
                        <Field type="password" name="password" placeholder="**********" class={errors.password ? "form-control h-auto py-6 rounded-lg border-danger is-invalid" : "form-control h-auto py-6 rounded-lg border-1"} autocomplete="off" />
                        <span class="form-text text-muted pl-4">min. 10 Zeichen</span>
                      </div>
                      <div class="form-group">
                        <label class="font-size-h5"><span class="font-weight-bolder text-dark">Passwort</span> - Wiederholung</label>
                        <Field type="password" name="password2" placeholder="**********" class={errors.password2 ? "form-control h-auto py-6 rounded-lg border-danger is-invalid" : "form-control h-auto py-6 rounded-lg border-1"} autocomplete="off" />
                      </div>
                      <div class="pb-lg-0 pb-5">
                      {
                          this.state.isLoading
                            ? <button type="submit" id="kt_login_singin_form_submit_button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3 spinner spinner-right spinner-white pr-15" disabled={isSubmitting}>Absenden</button>
                            : <button type="submit" id="kt_login_singin_form_submit_button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3" disabled={isSubmitting}>Absenden</button>
                        }
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Register;